import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, take } from 'rxjs';
import UploadedAttachmentMetaData from './models/UploadedAttachmentMetaData';

@Injectable({
  providedIn: 'root'
})
export class AttachmentService {

  constructor(private http$: HttpClient) { }

  
  
  downloadAttachment(attachmentId: number) {
    const url = `/api/attachments/${attachmentId}`;
    return this.http$.get(url, {
      responseType: 'blob', // Important for binary data
      observe: 'response'   // Needed to access headers like filename
    });
  }

  getAttachmentsListForEntity(entityId: number, entityType: string, attachmentType: string): Observable<UploadedAttachmentMetaData[]> {
    let params = new HttpParams()
      .set('entityType', entityType);

    if (attachmentType && attachmentType.length > 0) {
      params = params.append('attachmentType', attachmentType);
    }

    return this.http$.get<UploadedAttachmentMetaData[]>(`/api/attachments/list/${entityId}`, { params })
      .pipe(take(1));
  }

  getAttachmentsMetaDataListForEntity(entityId: number, entityType: string, attachmentType: string): Observable<UploadedAttachmentMetaData[]> {
    let params = new HttpParams()
      .set('entityType', entityType);

    if (attachmentType && attachmentType.length > 0) {
      params = params.append('attachmentType', attachmentType);
    }
    return this.http$.get<UploadedAttachmentMetaData[]>(`/api/attachments/meta/${entityId}`, { params })
      .pipe(take(1));
  }
}
